/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import ColorPicker from 'react-best-gradient-color-picker';
import { hexToRGBA } from "./Converts";
import { RowConfig } from "../../../Contens";
export default function ColorSolido(_a) {
    var gradiend = _a.gradiend, setData = _a.setData, c = _a.color, _b = _a.disableAlpha, disableAlpha = _b === void 0 ? false : _b, colores = _a.colores;
    var _c = useState(hexToRGBA(c)), color = _c[0], setColor = _c[1];
    var p = colores ? colores.map(function (c) { return hexToRGBA(c); }) : [];
    var present = p.filter(function (c) { return gradiend ? true : !(c.includes('gradient')); });
    useEffect(function () { return setData(color); }, [color]);
    return React.createElement(RowConfig, { style: { padding: '.5rem .5rem .5rem .5rem', background: '#eeeeee' } },
        React.createElement(ColorPicker, { value: color, onChange: setColor, hidePresets: !present.length, presets: present, hideEyeDrop: true, hideColorTypeBtns: !gradiend, disableAlpha: disableAlpha, key: c + 'palete' }));
}
//# sourceMappingURL=Color.js.map